module.exports = __webpack_public_path__ + "img/dept.a414b5b6.png";